import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthUser } from 'src/app/shared/models/auth/AuthUser';
import { LabDetails } from 'src/app/shared/models/labs/LabDetails';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { LabsService } from 'src/app/shared/services/labs.service';
import { SwalService } from 'src/app/shared/services/swal.service';
import { VerificationService } from 'src/app/shared/services/verification.service';
import { LabFormComponent } from '../lab-form/lab-form.component';
import { ModelsEnum } from 'src/app/shared/models/users/users/enums/ModelsEnum';
import { VerifyMobileComponent } from 'src/app/shared/components/verify-mobile/verify-mobile.component';
import { EntityEnumSLA } from 'src/app/shared/models/sla/enums/EntityEnumSLA';

@Component({
  selector: 'app-lab-profile',
  templateUrl: './lab-profile.component.html'
})
export class LabProfileComponent implements OnInit {
  selectedRecord: any;
  dataLoading = false;
  modelsEnum = ModelsEnum;

  labId!: number;
  details: LabDetails = new LabDetails();
  isOurProfile = false;
  isOurProfileVl = false;
  currentUser: AuthUser | null = new AuthUser();
  entityEnumSLA = EntityEnumSLA;

  constructor(
    public dialog: MatDialog,
    private service: LabsService,
    public translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private auth: AuthenticationService,
    private router: Router,
    private verifyService: VerificationService,
    private swalService: SwalService
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.labId = Number(params.get('id'));
        this.getDetails();
      } else {
        const currentRoute = this.router.url.split('/')[this.router.url.split('/').length - 1];

        if (currentRoute === 'vlProfile') {
          this.isOurProfileVl = true;
        } else {
          this.isOurProfile = true;
        }
        this.getLabProfileDetails();
      }
    });
    this.service.refreshDetails.subscribe((data: any) => {
      if (data) {
        if (this.isOurProfile || this.isOurProfileVl) {
          this.getLabProfileDetails();
        } else {
          this.getDetails();
        }
      }
    });
  }

  getDetails() {
    this.dataLoading = true;
    this.service.getDetails(this.labId).subscribe(
      (data: any) => {
        if (data) {
          this.details = data as LabDetails;
          this.details.id = this.labId;
          this.dataLoading = false;
        }
      },
      (error: any) => {
        this.dataLoading = false;
        if (this.hasPermission('SuperAdmin')) {
          this.router.navigate(['/admin/labs']);
        } else {
          this.router.navigate(['/admin/branches/lab']);
        }

      });
  }

  getLabProfileDetails() {
    this.dataLoading = true;
    this.service.getLabProfileDetails().subscribe(
      (data: any) => {
        if (data) {
          this.details = data as LabDetails;
          this.dataLoading = false;
        }
      },
      (error: any) => {
        this.dataLoading = false;
        // this.router.navigate(['/admin/labs']);
      });
  }

  openLabForm(addBranch: any) {
    const dialogRef = this.dialog.open(LabFormComponent, {
      width: '600px',
      data: {
        recordId: this.labId,
        record: !addBranch ? this.details : null,
        addBranch,
        isOurProfile: !addBranch ? this.isOurProfile : false,
        isOurProfileVl: !addBranch ? this.isOurProfileVl : false
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (this.isOurProfile || this.isOurProfileVl) {
          this.getLabProfileDetails();
        } else {
          this.getDetails();
        }
      }
    });
  }

  deleteRecord(labId: any) {
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.Yesdeleteit'))
      .then((result: any) => {
        if (result.value) {
          this.dataLoading = true;
          this.service.deleteRecord(labId).subscribe(
            (data: any) => {
              if (data) {
                this.dataLoading = false;
                this.swalService.swalSuccess()
                  .then(() => {
                    if (labId === this.labId) {
                      this.router.navigate(['/admin/labs']);
                    } else {
                      this.getDetails();
                    }
                  });
              }
            },
            (err: any) => {
              this.dataLoading = false;
              // console.log('Try again!, ' + error);
              const errors = JSON.parse(err.detail);
              let message = '';
              if (err.detail) {
                errors.ErrorDTO.forEach((error: any) => {
                  if (error.ErrorCode === 'CantDelete') {
                    message = error.Error;
                  }
                });
              } else {
                message = err.title;
              }
              this.swalService.swalFailed(message);
            });
        }
      });
  }

  verfiyEmail() {
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes'), this.translate.instant('swalMsg.verifyEmail')).then((result: any) => {
      if (result.value) {
        this.dataLoading = true;
        const record = {
          entityId: this.labId ? this.labId : this.currentUser?.ObjectValue,
          entityType: this.isOurProfileVl ? EntityEnumSLA.vl : EntityEnumSLA.lab
        };
        this.verifyService.sendVerifyEntityEmail(record).subscribe(
          (data: any) => {
            if (data) {
              this.dataLoading = false;
              this.swalService.swalSuccess(this.translate.instant('swalMsg.sendSuccessfully'))
                .then(() => {
                  // this.getDetails();
                  // this.service.refreshProfileBraches.next(true);
                });
            }
          },
          (err: any) => {
            this.dataLoading = false;
            // console.log('Try again!, ' + error);
            this.swalService.swalFailed(err.title);
          });
      }
    });
  }

  verifyMobile() {
    const entityType = this.isOurProfileVl ? EntityEnumSLA.vl : EntityEnumSLA.lab
    const dataRecord = {
      entityId: this.labId ? this.labId : this.currentUser?.ObjectValue,
      entityType: entityType,
      title: this.translate.instant("swalMsg.verifyMobileOf") + entityType,
      message: this.translate.instant("swalMsg.weHaveSentOneTimePassword") + entityType + '.'
    };
    const dialogRef = this.dialog.open(VerifyMobileComponent, {
      width: '750px',
      data: dataRecord
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.service.refreshDetails.next(true);
      }
    });
  }

  hasPermission(permission: string) {
    return this.auth.hasPermission(permission);
  }

}
